import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Dialog,
  IconButton,
  Modal,
  Slide,
  Tab,
  Tabs,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { WorkflowContext } from '../../../contexts/WorkflowProvider';
import DedupeAgentLog from '../../../reusable-component/dedupe-agent/DedupeAgentLog';
import LoadingIcon from '../../../reusable-component/LoadingIcon';
import generateAlias from '../../../utils/generateAlias';
import { getAWSLogsByLogstreams, getAWSLogstreams } from "../../../api's/LogsApi";

const styleLoading = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

function NodeModal_DeduplicationAgent({ open, handleClose, nodeId, nodeName, nodes, edges, changeNodeName, setNodes }) {
  const { enqueueSnackbar } = useSnackbar();
  const INITIALSTATE = {
    alias: generateAlias(nodeName, nodeId),
    df: '',
    dqRules: [],
    col_list: [],
    lowerBound: nodeId,
  };
  const pollingRef = useRef(null); // To store interval ID
  const [formField, setFormField] = useState(INITIALSTATE);
  const { workflow } = useContext(WorkflowContext);
  const [value, setValue] = useState(0);
  const [disableForm, setDisableForm] = useState(false);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [headerName, setHeaderName] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);
  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const [formattedFields, setFormattedFields] = useState([]);
  const [columnName, setColumnName] = useState([]);
  const [dqRules, setDqRules] = useState([]);
  // const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState([]);

  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) =>
    first_array_of_objects.length === second_array_of_objects.length &&
    first_array_of_objects.every((element_1) =>
      second_array_of_objects.some(
        (element_2) =>
          element_1.header === element_2.header &&
          element_1.tableAlias === element_2.tableAlias &&
          element_1.alias === element_2.alias &&
          element_1.checked === element_2.checked
      )
    );

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    console.log('message: ', message);

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    const updatedFormField = { ...formField, dqRules };
    console.log('UpdatedField : ', updatedFormField);

    setHeaderName(newHeaderName);

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField: updatedFormField,
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      columnName,
      fetchedHeader,
      dqRules,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });
    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  const handleChange = (event, newValue) => {
    const incompleteSamples = headerName.some((column) => !column.sampleValue1 || !column.sampleValue2);

    if (incompleteSamples) {
      enqueueSnackbar(
        'Please provide both Sample Value 1 and Sample Value 2 for all selected columns before proceeding.',
        {
          variant: 'warning',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        }
      );
    } else {
      setValue(newValue);
    }
  };

  const getSourceData = () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });
    const paths = [];

    if (store && findSrcNodeId) {
      let header = [];

      let prev_alias;
      let prev_nodeName;
      let prev_nodeId;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            paths.push(node.formField.path);
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
            prev_nodeId = node.nodeId;
          }
        });
      });
      setFormField((prev) => ({ ...prev, df: prev_alias, col_list: paths }));

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: el.alias ? el.alias : head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const head = [];
      const newHeader = uniqueArray.map((el) => ({
        ...el,
        header: el.alias ? el.alias : el.header,
        alias: el.alias ? el.alias : '',
      }));

      newHeader.forEach((el) => {
        head.push({ label: el.header });
      });

      setFetchedHeader(newHeader);
      setColumnName(newHeader.map((item) => ({ id: item.header, label: item.header })));

      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField({ ...node.formField, col_list: paths });
          setDqRules(node.formField.dqRules);
          setFormattedFields(
            node.headerName.map((item) => ({
              fields: [
                {
                  fieldName: item.header,
                  fieldValues: [item.sampleValue1, item.sampleValue2],
                },
              ],
              target_column: item.header,
            }))
          );
          setHeaderName(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          setColumnName(node.columnName);
          setTempHeader(node.headerName);

          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    getSourceData();
    fetchLogs();
    // getRuleSelectorMetricList();
  }, [nodeId]);

  const store = JSON.parse(sessionStorage.getItem('allNodes'));
  const fetchLogs = async () => {
    setLoading(true);
    try {
      const filePath = `xmdm-agentic-logs-${workflow.workflow_id}-`;

      const payload = {
        workflow_type: 'Dedupe',
        prefix: filePath,
      };
      const response = await getAWSLogstreams(payload);
      if (response.status === 200 && response.data.length > 0) {
        const logstreamsPayload = {
          workflow_type: 'Dedupe',
          log_stream: response.data[0]?.log_stream_name,
        };
        const responseData = await getAWSLogsByLogstreams(logstreamsPayload);

        if (responseData.status === 200 && responseData.data.length > 0) {
          setMessage(responseData.data);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const refreshAllState = () => {
    handleRefreshModalOpen();

    let updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem('updatedNodes', JSON.stringify(updateNodes));

    const findSrcNodeId = [];

    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);

      enqueueSnackbar('No source node is connected !!!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      handleRefreshModalClose();
      return;
    }

    let nodesExist = false;
    const paths = [];

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      let header = [];

      let prev_alias;
      let prev_nodeName;
      let prev_nodeId;
      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            paths.push(node.formField.path);
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
            prev_nodeId = node.nodeId;
          }
        });
      });
      setFormField((prev) => ({ ...prev, df: prev_alias, col_list: paths }));
      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: el.alias ? el.alias : head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const newHeader = uniqueArray.map((el) => {
        return { ...el, header: el.alias ? el.alias : el.header, alias: el.alias ? '' : el.alias };
      });

      if (nodesExist) {
        store.forEach((node) => {
          if (node.nodeId === nodeId) {
            setFormField({ ...node.formField, col_list: paths });
            setDqRules(node.formField.dqRules);
            setFormattedFields(
              node.headerName.map((item) => ({
                fields: [
                  {
                    fieldName: item.header,
                    fieldValues: [item.sampleValue1, item.sampleValue2],
                  },
                ],
                target_column: item.header,
              }))
            );
            setHeaderName(node.headerName);

            const nonExistingHeader = [];
            node.fetchedHeader.forEach((item) => {
              const index = newHeader.findIndex((x) => x.header === item.header);

              if (index !== -1) {
                nonExistingHeader.push(item);
              }
            });

            newHeader.forEach((el) => {
              const index = nonExistingHeader.findIndex((x) => x.header === el.header);

              if (index === -1) {
                nonExistingHeader.push({
                  ...el,
                  header: el.alias ? el.alias : el.header,
                  alias: el.alias ? '' : el.alias,
                });
              }
            });

            setFetchedHeader(nonExistingHeader);
          }
        });
      } else {
        setFetchedHeader(newHeader);
      }
    }
    enqueueSnackbar('Data Refreshed!!!', {
      variant: 'Success',
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
    handleRefreshModalClose();
  };
  const handleRefreshLogs = async () => {
    // Stop polling if already running
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
      setLoading(false);
      console.log('Polling stopped');
      return;
    }

    setLoading(true);

    const filePath = `xmdm-agentic-logs-${workflow.workflow_id}-`;
    const workflowType = 'Dedupe';

    try {
      // Call this only once on refresh
      const logstreamsResponse = await getAWSLogstreams({ workflow_type: workflowType, prefix: filePath });

      if (logstreamsResponse.status !== 200 || logstreamsResponse.data.length === 0) {
        console.log('No log streams found');
        setLoading(false);
        return;
      }

      const logStreamName = logstreamsResponse.data[0].log_stream_name;

      // Function to fetch logs from the specific log stream
      const fetchLogs = async () => {
        try {
          const logsResponse = await getAWSLogsByLogstreams({ workflow_type: workflowType, log_stream: logStreamName });

          if (logsResponse.status === 200 && logsResponse.data.length > 0) {
            setMessage(logsResponse.data);
          }
        } catch (error) {
          console.log('Error fetching logs:', error);
        }
      };

      // Initial fetch
      await fetchLogs();
      setLoading(false);

      // Start polling every 5 seconds
      pollingRef.current = setInterval(fetchLogs, 5000);
      console.log('Polling started');
    } catch (error) {
      console.log('Error fetching log streams:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
      }
    };
  }, []);

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        style={{ width: '70%', marginLeft: '30%' }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {nodeName}
              </Typography>
              <Tooltip title="Refresh Schema" placement="left">
                <IconButton
                  disabled={disableForm}
                  edge="start"
                  onClick={refreshAllState}
                  aria-label="close"
                  sx={{ color: '#00043C' }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={!disableForm}
                  className="outlined-button-color"
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="fullWidth"
              sx={{
                width: '100%',
                color: '#000',
                '& button': { backgroundColor: '#eee' },
                '& button:focus': { color: 'white', backgroundImage: 'linear-gradient(to right, #4880EC, #019CAD)' },
                '& button.Mui-selected': {
                  color: 'white',
                  backgroundImage: 'linear-gradient(to right, #4880EC, #019CAD)',
                },
              }}
            >
              <Tab label="Logs" disabled={disableForm} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0} sx={{ width: '100%' }}>
            <DedupeAgentLog data={message} onRefresh={handleRefreshLogs} />
          </TabPanel>
        </form>
      </Dialog>
      <Modal open={refreshModalOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  );
}

export default NodeModal_DeduplicationAgent;
